/**
 * Defines the enum for redirects clients (ios, android, desktop) dropdown.
 */
export enum RedirectsClientOverride {
  WebUrl = 'WebUrl',
  Deepview = 'Deepview',
  DefaultRedirect = 'DefaultRedirect',
}
